window.Vivense = window.Vivense || {};

Vivense.populate = (function($) {

    var exports = {};

    function insertEvent(scenario, page, from_action, design, user_action, callback) {
        $.ajax({
            url: '/ajax/user/insert_populate.php',
            method: 'POST',
            data: "scenario=" + scenario + "&page=" + page + "&from_action=" + from_action + "&design=" + design + "&user_action=" + user_action,
            cache: false
        }).done(function () {

        }).always(function () {
            if(callback){
                callback();
            }
        });
    }

    exports.insertEvent = insertEvent;

    return exports;

})(jQuery);